import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { invalidIds } from "../../../utility";

const DefinitionPopup = ({
  open,
  onClose,
  formData,
  errors,
  onChange,
  handleSubmit,
  sepcificaitonForm,
  fieldType,
  setFieldType,
  handleAcceptanceValueChange,
  handleDeleteAcceptanceValue,
  handleAddAcceptanceValue,
  handleBlockChange,
  handleDeleteBlock,
  handleAddBlock,
  parameter,
  limitOperation,
  handleSaveAsDraft,
  addTargetData,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const specNames = [
    "IPL-Alert",
    "IPL-Action",
    "IPL-Accept",
    "IPM",
    "Spec-Release",
    "Spec-Stability",
    "AQL",
    "Internal - Release",
    "IPC",
  ];
  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  useEffect(() => {}, [open]);
 
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted={false}
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 16,
          m: 0,
          width: isEdit ? 400 : 500,
          maxHeight: "calc(100% - 142px)",
          height: "100%",
          boxShadow: "none",
          elevation: 0,
          border: "1px solid #ccc",
          p: 1,
          transition: "width 0.3s ease",
        },
      }}
    >
      <>
        {" "}
        <>
          <DialogTitle className="dialog-title">
            <Label
              text="Add Limit"
              color="#fff"
              fontSize="14px"
              fontWeight="500"
            ></Label>

            <BackButtons onClick={handleClose} />
          </DialogTitle>
          <DialogContent sx={{ padding: 0.5 }}>
            <Box className="dialog-box">
              <Buttons
                text={"Control"}
                colors={fieldType === "control" ? "gray" : "default"}
                onClick={() => setFieldType("control")}
              />
              <Buttons
                colors={fieldType === "specification" ? "gray" : "default"}
                text={"Specification"}
                onClick={() => setFieldType("specification")}
              />
              {/* <Buttons
                colors={fieldType === "target" ? "gray" : "default"}
                text={"Target"}
                onClick={() => setFieldType("target")}
              /> */}
            </Box>
            {fieldType === "control" && (
              <>
                <Box
                  sx={{
                    // width: 300,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    paddingTop: 1,
                  }}
                >
                  <TextField
                    select
                    variant="outlined"
                    label="Parameter Name"
                    name="parameter_id"
                    fullWidth
                    value={formData?.parameter_id}
                    onChange={onChange}
                    required
                    error={!!errors?.parameter_id}
                    helperText={errors?.parameter_id}
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "14px",
                        backgroundColor: "#fff",
                        padding: "0 4px",
                      },
                    }}
                  >
                    <MenuItem value="" defaultChecked>
                      <>Unit of Measurement</>
                    </MenuItem>
                    {parameter?.parameter_names?.map((item) => (
                      <MenuItem value={item.parameter_id}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Box display={"flex"} gap={1.5} sx={{ py: 1 }}>
                    <TextField
                      label="Valid From"
                      variant="outlined"
                      name="validFrom"
                      type="date"
                      fullWidth
                      size="small"
                      value={formData?.valid_from}
                      onChange={onChange}
                      InputLabelProps={{ shrink: true }}
                      error={!!errors?.validFrom}
                      helperText={errors?.validFrom}
                      required
                    />
                    <TextField
                      label="Valid Through"
                      variant="outlined"
                      name="validThrough"
                      type="date"
                      fullWidth
                      size="small"
                      value={formData?.validThrough}
                      onChange={onChange}
                      InputLabelProps={{ shrink: true }}
                      error={!!errors?.validThrough}
                      helperText={errors?.validThrough}
                    />
                  </Box>
                  <TextField
                    fullWidth
                    label="Box-Cox transformation (λ) value"
                    name="boxCoxLambdaValue"
                    variant="outlined"
                    size="small"
                    type="number"
                    value={formData?.boxCoxLambdaValue}
                    onChange={onChange}
                    error={!!errors?.boxCoxLambdaValue}
                    helperText={errors?.boxCoxLambdaValue}
                  />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="LCL"
                      name="lcl"
                      variant="outlined"
                      size="small"
                      value={formData?.lcl}
                      onChange={onChange}
                      error={!!errors?.lcl}
                      helperText={errors?.lcl}
                      type="number"
                      required
                    />
                    <TextField
                      fullWidth
                      label="UCL"
                      name="ucl"
                      size="small"
                      variant="outlined"
                      value={formData?.ucl}
                      onChange={onChange}
                      error={!!errors?.ucl}
                      helperText={errors?.ucl}
                      type="number"
                      required
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="LWL"
                      name="lwl"
                      variant="outlined"
                      size="small"
                      value={formData?.lwl}
                      onChange={onChange}
                      error={!!errors?.lwl}
                      helperText={errors?.lwl}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="UWL"
                      name="uwl"
                      variant="outlined"
                      size="small"
                      value={formData?.uwl}
                      onChange={onChange}
                      error={!!errors?.uwl}
                      helperText={errors?.uwl}
                      type="number"
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="LIL"
                      name="lil"
                      variant="outlined"
                      size="small"
                      value={formData?.lil}
                      onChange={onChange}
                      error={!!errors?.lil}
                      helperText={errors?.lil}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="UIL"
                      name="uil"
                      variant="outlined"
                      size="small"
                      value={formData?.uil}
                      onChange={onChange}
                      error={!!errors?.uil}
                      helperText={errors?.uil}
                      type="number"
                    />
                  </Box>

                  <TextField
                    fullWidth
                    label="Mean"
                    name="mean"
                    variant="outlined"
                    size="small"
                    value={formData?.mean}
                    onChange={onChange}
                    error={!!errors?.mean}
                    helperText={errors?.mean}
                    type="number"
                  />

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="ST Std dev"
                      name="ststddev"
                      size="small"
                      variant="outlined"
                      value={formData?.stsddev}
                      onChange={onChange}
                      error={!!errors?.stsddev}
                      helperText={errors?.stsddev}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="LT Std dev"
                      name="ltstddev"
                      size="small"
                      variant="outlined"
                      value={formData?.ltstddev}
                      onChange={onChange}
                      error={!!errors?.ltstddev}
                      helperText={errors?.ltstddev}
                      type="number"
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="Cp"
                      name="cp"
                      variant="outlined"
                      size="small"
                      value={formData?.cp}
                      onChange={onChange}
                      error={!!errors?.cp}
                      helperText={errors?.cp}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="Cpl"
                      name="cpl"
                      variant="outlined"
                      size="small"
                      value={formData?.cpl}
                      onChange={onChange}
                      error={!!errors?.cpl}
                      helperText={errors?.cpl}
                      type="number"
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="Cpu"
                      name="cpu"
                      variant="outlined"
                      size="small"
                      value={formData?.cpu}
                      onChange={onChange}
                      error={!!errors?.cpu}
                      helperText={errors?.cpu}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="Cpk"
                      name="cpk"
                      variant="outlined"
                      size="small"
                      value={formData?.cpk}
                      onChange={onChange}
                      error={!!errors?.cpk}
                      helperText={errors?.cpk}
                      type="number"
                    />
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="Pp"
                      name="pp"
                      size="small"
                      variant="outlined"
                      value={formData?.pp}
                      onChange={onChange}
                      error={!!errors?.pp}
                      helperText={errors?.pp}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="Ppl"
                      name="ppl"
                      size="small"
                      variant="outlined"
                      value={formData?.ppl}
                      onChange={onChange}
                      error={!!errors?.ppl}
                      helperText={errors?.ppl}
                      type="number"
                    />
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      label="Ppu"
                      name="ppu"
                      variant="outlined"
                      size="small"
                      value={formData?.ppu}
                      onChange={onChange}
                      error={!!errors?.ppu}
                      helperText={errors?.ppu}
                      type="number"
                    />
                    <TextField
                      fullWidth
                      label="Ppk"
                      name="ppk"
                      variant="outlined"
                      size="small"
                      value={formData?.ppk}
                      onChange={onChange}
                      error={!!errors?.ppk}
                      helperText={errors?.ppk}
                      type="number"
                    />
                  </Box>
                  <TextField
                    fullWidth
                    label="Change Reason"
                    name="changeReason"
                    variant="outlined"
                    size="small"
                    value={formData?.changeReason}
                    onChange={onChange}
                    // required
                    // error={!!errors?.changeReason}
                    // helperText={errors?.changeReason}
                  />
                </Box>
              </>
            )}
            {fieldType === "specification" && (
              <>
                <>
                  <Box
                    sx={{
                      // width: 300,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      select
                      variant="outlined"
                      label="Parameter Name"
                      name="parameter_id"
                      required
                      fullWidth
                      value={sepcificaitonForm?.parameter_id}
                      onChange={onChange}
                      error={!!errors?.parameter_id}
                      helperText={errors?.parameter_id}
                      size="small"
                      InputLabelProps={{
                        style: {
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "0 4px",
                        },
                      }}
                    >
                      <MenuItem value="">
                        <>Select</>
                      </MenuItem>
                      {parameter?.parameter_names?.map((item) => (
                        <MenuItem value={item.parameter_id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Box display={"flex"} gap={1} sx={{ py: 1 }}>
                      <TextField
                        label="Valid From"
                        variant="outlined"
                        name="validFrom"
                        fullWidth
                        type="date"
                        size="small"
                        value={sepcificaitonForm?.validFrom}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validFrom}
                        helperText={errors?.validFrom}
                        required
                      />
                      <TextField
                        label="Valid Through"
                        variant="outlined"
                        name="validThrough"
                        type="date"
                        fullWidth
                        size="small"
                        value={sepcificaitonForm?.validThrough}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validThrough}
                        helperText={errors?.validThrough}
                      />
                    </Box>
                    {/* <TextField
                      fullWidth
                      label="Box-Cox transformation (λ) value"
                      name="boxCoxLambdaValue"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.boxCoxLambdaValue}
                      onChange={onChange}
                      error={!!errors?.boxCoxLambdaValue}
                      helperText={errors?.boxCoxLambdaValue}
                    />
                    <TextField
                      fullWidth
                      label="Process Target"
                      name="processTarget"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.process_target}
                      onChange={onChange}
                      error={!!errors?.process_target}
                      helperText={errors?.process_target}
                    /> */}
                    <TextField
                      fullWidth
                      label="Acceptance Criteria"
                      name="acceptanceCriteria"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.acceptanceCriteria}
                      onChange={onChange}
                      error={!!errors?.acceptanceCriteria}
                      helperText={errors?.acceptanceCriteria}
                    />
                    <TextField
                      fullWidth
                      label="Method"
                      name="method"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.method}
                      onChange={onChange}
                      error={!!errors?.method}
                      helperText={errors?.method}
                    />
                    <TextField
                      fullWidth
                      label="Change Reason"
                      name="changeReason"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.changeReason}
                      onChange={onChange}
                      // error={!!errors?.changeReason}
                      // helperText={errors?.changeReason}
                      // required
                    />
                    <TextField
                      fullWidth
                      label="Process Target"
                      name="processTarget"
                      variant="outlined"
                      size="small"
                      // required
                      value={sepcificaitonForm?.processTarget}
                      onChange={onChange}
                      error={!!errors?.processTarget}
                      helperText={errors?.processTarget}
                    />
                    <Box sx={{ mt: 1, border: 1, p: 1, borderColor: "#ccc" }}>
                      <Label
                        variant="subtitle1"
                        gutterBottom
                        text={"Acceptable Values"}
                      ></Label>

                      <Stack spacing={2}>
                        {sepcificaitonForm?.acceptanceValue?.map(
                          (value, index) => (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              gap={1}
                            >
                              <TextField
                                fullWidth
                                label={`Value ${index + 1}`}
                                value={value}
                                type="number"
                                // required
                                size="small"
                                error={!!errors?.acceptanceValue?.[index]}
                                onChange={(e) =>
                                  handleAcceptanceValueChange(
                                    "add",
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                              <IconButton
                                onClick={() =>
                                  handleDeleteAcceptanceValue("add", index)
                                }
                                color="error"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          )
                        )}
                      </Stack>

                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={handleAddAcceptanceValue}
                        sx={{ mt: 2 }}
                      >
                        Add Acceptance Value
                      </Button>
                    </Box>
                    {!invalidIds.includes(sepcificaitonForm?.parameter_id) && (
                      <>
                        <TextField
                          select
                          variant="outlined"
                          label="Specification limit name"
                          name="spec_name"
                          fullWidth
                          value={sepcificaitonForm?.spec_name}
                          onChange={onChange}
                          error={!!errors?.spec_name}
                          helperText={errors?.spec_name}
                          size="small"
                          InputLabelProps={{
                            style: {
                              fontSize: "14px",
                              backgroundColor: "#fff",
                              padding: "0 4px",
                            },
                          }}
                        >
                          <MenuItem value="">
                            <>select</>
                          </MenuItem>
                          {specNames?.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </TextField>
                        <Box>
                          {sepcificaitonForm?.specificationLimitBlock?.map(
                            (block, index) => (
                              <Box
                                key={index}
                                sx={{
                                  pb: 2,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1,
                                }}
                              >
                                <Box display="flex" gap={1}>
                                  <TextField
                                    select
                                    size="small"
                                    sx={{ minWidth: "80px" }}
                                    name="lowerLimitType"
                                    value={block.lowerLimitType}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitType
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitType
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "lowerLimitType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value={null}>Select</MenuItem>
                                    {[">=", ">"].map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                                  </TextField>

                                  <TextField
                                    fullWidth
                                    label="Lower Limit Value"
                                    type="number"
                                    size="small"
                                    name={`lowerLimitValue`}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitValue
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.lowerLimitValue
                                    }
                                    value={block.lowerLimitValue}
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "lowerLimitValue",
                                        e.target.value
                                      )
                                    }
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          {block.lowerLimitType}
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Box>
                                {/* Upper limit */}
                                <Box display="flex" gap={1}>
                                  <TextField
                                    select
                                    size="small"
                                    sx={{ minWidth: "80px" }}
                                    name="upperLimitType"
                                    value={block.upperLimitType}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitType
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitType
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "upperLimitType",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <MenuItem value={null}>Select</MenuItem>
                                    {["<", "<="].map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                                  </TextField>

                                  <TextField
                                    fullWidth
                                    label="Upper Limit Value"
                                    type="number"
                                    size="small"
                                    name="upperLimitValue"
                                    value={block.upperLimitValue}
                                    error={
                                      !!errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitValue
                                    }
                                    helperText={
                                      errors?.specificationLimitBlock?.[index]
                                        ?.upperLimitValue
                                    }
                                    onChange={(e) =>
                                      handleBlockChange(
                                        "add",
                                        index,
                                        "upperLimitValue",
                                        e.target.value
                                      )
                                    }
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          {block.upperLimitType}
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Box>

                                {/* Delete button */}
                                {sepcificaitonForm?.specificationLimitBlock
                                  .length > 1 && (
                                  <IconButton
                                    onClick={() =>
                                      handleDeleteBlock("add", index)
                                    }
                                    sx={{
                                      position: "absolute",
                                      bottom: 0,
                                      right: 8,
                                    }}
                                    color="error"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                              </Box>
                            )
                          )}

                          {/* <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => handleAddBlock("add")}
                      >
                        Add Specification Block
                      </Button> */}
                        </Box>
                      </>
                    )}
                  </Box>
                </>
              </>
            )}
            {fieldType === "target" && (
              <>
                <>
                  <Box
                    sx={{
                      // width: 300,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      paddingTop: 1,
                    }}
                  >
                    <TextField
                      select
                      variant="outlined"
                      label="Parameter Name"
                      name="parameter_id"
                      required
                      fullWidth
                      value={addTargetData?.parameter_id}
                      onChange={onChange}
                      error={!!errors?.parameter_id}
                      helperText={errors?.parameter_id}
                      size="small"
                      InputLabelProps={{
                        style: {
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "0 4px",
                        },
                      }}
                    >
                      <MenuItem value="">
                        <>Select</>
                      </MenuItem>
                      {parameter?.parameter_names?.map((item) => (
                        <MenuItem value={item.parameter_id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <Box display={"flex"} gap={1} sx={{ py: 1 }}>
                      <TextField
                        label="Valid From"
                        variant="outlined"
                        name="validFrom"
                        fullWidth
                        type="date"
                        size="small"
                        value={addTargetData?.validFrom}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validFrom}
                        helperText={errors?.validFrom}
                        required
                      />
                      <TextField
                        label="Valid Through"
                        variant="outlined"
                        name="validThrough"
                        type="date"
                        fullWidth
                        size="small"
                        value={addTargetData?.validThrough}
                        onChange={onChange}
                        InputLabelProps={{ shrink: true }}
                        error={!!errors?.validThrough}
                        helperText={errors?.validThrough}
                      />
                    </Box>
                    {/* <TextField
                      fullWidth
                      label="Box-Cox transformation (λ) value"
                      name="boxCoxLambdaValue"
                      variant="outlined"
                      size="small"
                      value={sepcificaitonForm?.boxCoxLambdaValue}
                      onChange={onChange}
                      error={!!errors?.boxCoxLambdaValue}
                      helperText={errors?.boxCoxLambdaValue}
                    /> */}
                    <TextField
                      fullWidth
                      label="Process Target"
                      name="processTarget"
                      variant="outlined"
                      size="small"
                      required
                      value={addTargetData?.processTarget}
                      onChange={onChange}
                      error={!!errors?.processTarget}
                      helperText={errors?.processTarget}
                    />
                    <TextField
                      fullWidth
                      label="Change Reason"
                      name="changeReason"
                      variant="outlined"
                      size="small"
                      value={addTargetData?.changeReason}
                      onChange={onChange}
                      // error={!!errors?.changeReason}
                      // helperText={errors?.changeReason}
                      // required
                    />
                  </Box>
                </>
              </>
            )}
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: 1,
              borderTop: "1px solid #ccc",
            }}
          >
            <Buttons
              size="small"
              text="Submit"
              onClick={handleSubmit}
              loading={limitOperation?.loader}
            />
            <Buttons
              size="small"
              text="Save Draft"
              onClick={handleSaveAsDraft}
              loading={limitOperation?.draftLoader}
            />
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={onClose}
            />
          </DialogActions>
        </>
      </>
    </Dialog>
  );
};

export default DefinitionPopup;
